import React, { useContext } from "react";
import { observer } from "mobx-react";

import { OfferStoreContext } from "@gp/components";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { EventBodyTabs } from "@data-types/offer/event/EventViewStoreEnums";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";

import { GroupedBettingTypes } from "@features/offer/desktop/grouped-event-offer/components";

export const EventMarketsContent = observer(function EventMarketsContent() {
	const store = useContext(OfferStoreContext) as
		| EventViewStore
		| AdditionalOfferViewStore;

	if (store.currentTab === EventBodyTabs.Markets) {
		return <GroupedBettingTypes />;
	}
	return null;
});
